
import React from 'react';
import { motion } from 'framer-motion';

const PartnerProblem = () => {
  return (
    <section className="py-32 bg-juv-cream-white">
      <div className="container mx-auto px-6 max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h2 className="text-5xl md:text-6xl font-serif font-light text-juv-deep-chestnut mb-12">
            Most dental offices are capped out.
          </h2>
          
          <p className="text-2xl text-juv-deep-chestnut/80 leading-relaxed max-w-4xl mx-auto">
            You're competing on PPOs, your ops are maxed, and hygiene can't scale. Meanwhile, medspas are exploding in demand—and your patients are already paying someone else for Botox, facials, and whitening.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default PartnerProblem;
